import { getIsMobile } from '../helpers';

class LiveChat {
  // eslint-disable-next-line class-methods-use-this
  init() {
    function onReady() {
      // Chat Widget is ready
      $('#chat-widget-container').addClass('liveChat');
    }

    // eslint-disable-next-line no-undef
    if (typeof LiveChatWidget !== 'undefined' && !getIsMobile()) {
      // eslint-disable-next-line no-undef
      LiveChatWidget.on('ready', onReady);
    }
  }
}

export default new LiveChat();
